import { render, staticRenderFns } from "./timedtabs.vue?vue&type=template&id=e49832a0&"
import script from "./timedtabs.vue?vue&type=script&lang=ts&"
export * from "./timedtabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e49832a0')) {
      api.createRecord('e49832a0', component.options)
    } else {
      api.reload('e49832a0', component.options)
    }
    module.hot.accept("./timedtabs.vue?vue&type=template&id=e49832a0&", function () {
      api.rerender('e49832a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/timedtabs/timedtabs.vue"
export default component.exports